import { call, put } from "redux-saga/effects";
import { fetchUIConfig, fetchMenuUIConfig } from "../requests/uiConfig";
import {
  fetchUIConfigSuccess,
  fetchUIConfigFailure,
} from "../../uiConfig/uiConfigAction";
import {
  startLoadingIndicator,
  stopLoadingIndicator,
} from "../../loadingIndicator/loadingIndicatorActions";

// import sampleJsonData from "./uiConfig.json";

export function* handleUIConfig() {
  try {
    yield put(startLoadingIndicator());
    // const { uiResponse, menuUIResponse } = sampleJsonData; //test
    const uiResponse = yield call(fetchUIConfig, "");
    const menuUIResponse = yield call(fetchMenuUIConfig, "");
    const { config } = parseResponse({ uiResponse, menuUIResponse });
    yield put(fetchUIConfigSuccess({ config }));
    yield put(stopLoadingIndicator());
  } catch (error) {
    console.log(`handleUIConfig error = ${error}`);
    yield put(fetchUIConfigFailure({ error }));
    yield put(stopLoadingIndicator());
  }
}

const parseResponse = ({ uiResponse, menuUIResponse }) => {
  if (uiResponse?.data?.data && menuUIResponse?.data?.data) {
    let uiConfig = uiResponse?.data?.data;
    let menuConfig = menuUIResponse?.data?.data;
    let config = uiConfig.map((section) => {
      let filterMenuConfig = menuConfig.filter(
        (menu) => menu.section_id?.id === section.id
      );
      filterMenuConfig = mapDataByLanguage([...filterMenuConfig]);
      section.menuItems = [...filterMenuConfig];
      return section;
    });
    config = mapDataByLanguage([...config]);
    return { config };
  }
  return { config: {} };
};

const mapDataByLanguage = (data) => {
  return data.map((m) => {
    return {
      en: {
        title: m?.title_en,
        desc: m?.desc_en,
        barcode: m?.barcode_en?.data?.full_url,
        linkUrl: m?.link_en_url,
      },
      ar: {
        title: m?.title_ar,
        desc: m?.desc_ar,
        barcode: m?.barcode_ar?.data?.full_url,
        linkUrl: m?.link_ar_url,
      },
      showTitleWeb: m?.show_title_web,
      showTitleKiosk: m?.show_title_kiosk,
      showInWeb: m?.show_in_web,
      showInKiosk: m?.show_in_kiosk,
      ...m,
    };
  });
};
